import Vue from 'vue'
import Router from 'vue-router'
import store from './store/store'

Vue.use(Router)

const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    next()
    return
  }
  next('/')
}

const ifAuthenticated = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    next()
    return
  }
  next('/login')
}

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('./views/Home'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/index.html',
      name: 'home',
      component: () => import('./views/Home'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/outgoing',
      name: 'Исходящий',
      component: () => import('./views/Out'),
      beforeEnter: ifAuthenticated,
    },{
      path: '/incoming',
      name: 'Входящий',
      component: () => import('./views/Income'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/clientService',
      name: 'Клиентский сервис',
      component: () => import('./views/ClientService'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/statsOutgoing',
      name: 'Реестр инф.',
      component: () => import('./views/stats'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/myRequest',
      name: 'мои заявки',
      component: () => import('./views/myRequest'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('./views/login')
    },
    {
      path: '/logout',
      name: 'logout',
      component: () => import('./views/logOut')
    },
    {
      path: '/editIncome',
      name: 'Редактирование входящих',
      component: () => import('./views/editIncome'),
      beforeEnter: ifAuthenticated,
    },
    {
      path:'/vdscr',
      name:'Видео скоринг',
      component: ()=>import('./views/videoScoring'),
      beforeEnter: ifAuthenticated,
    },
    {
      path:'/testPage',
      name:'testPage',
      component: () => import('./views/test')
    },
    {
      path:'/autoCC',
      name:'autoCC',
      component: () => import('./views/autoCC')
    },
    {
      path:'/editScripts/:id',
      name:'editScripts',
      component:() => import('./views/adminScriptContent/scriptRouting'),
    },
    {
      path:'*',
      name:'signIn',
      component: () => import('./views/PageNotFound')
    },
  ]
})
